import React from "react";
import styles from "../components/Section.scss";

const Section = props => {
  return (
    <div>
      <img src={props.icon} />
      <h1 className={styles.title}>{props.title}</h1>
      <h2
        className={styles.subtitle}
        dangerouslySetInnerHTML={{ __html: props.subtitle }}
      />

      {props.divider && (
        <div className={styles.divider}>
          <span className={styles.dividerLine} />
          <span className={styles.dividerLine} />
        </div>
      )}
    </div>
  );
};

export default Section;



// WEBPACK FOOTER //
// ./src/routes/candidate/signUpMarketing2/components/Section.js